


























export default {
  name: 'FlMovieImage',
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      hasError: false,
      size: { width: 0, height: 0 },
    };
  },
  watch: {
    value(newVal, oldVal) {
      this.hasError = false;
    },
  },
  methods: {
    onImageLoaded() {
      const img = document.querySelector('#movie_image');
      if (img) {
        this.size.width = (img as any).naturalWidth;
        this.size.height = (img as any).naturalHeight;
      }
    },
  },
  computed: {
    computedSrc() {
      if (!this.value || (this.value && this.hasError)) {
        return '@/assets/image/logo_gray.svg';
      } else {
        return this.value;
      }
    },
    isCorrectProportion() {
      if (this.size.width === 0 || this.size.height === 0) {
        return false;
      }
      return this.size.width * 9 === this.size.height * 16;
    },
    isPortrait() {
      if (this.size.width === 0 || this.size.height === 0) {
        return false;
      }
      return this.size.width < this.size.height;
    },
    isLandscape() {
      if (this.size.width === 0 || this.size.height === 0) {
        return false;
      }
      return this.size.width > this.size.height;
    },
  },
};
